<!-- <section id="main-section" class="pd-t40 pd-b40 pd-l40 pd-r40 pd-sm-20 lightgrey-bg"> -->
<form #feedbackForm="ngForm" (ngSubmit)="submit()">
    <div class="smallContainer mg-auto">
        <!-- Congratulations Section -->
        <article class="congo-wrap">
            <div class="congo-wrap__banner">
                <div class="d-flex">
                   <div><img src="assets/images/upgradRed/feedback.png" alt="" /></div>
                    <div class="congo-wrap__banner--cont">
                        <h2>Kudos, {{user?.firstName}}!</h2>
                        <p>Congratulations on finishing {{activationInfo && activationInfo?.title | titlecase}}!</p>
                        <p class="share hide-on-mobile">Please share your feedback and collect your certificate.
                        </p>
                    </div>
                </div>
                <!-- <div class="congo-wrap__banner--text d-flex hide-on-desktop">Your course score is being generated. To
                    view score, please share your feedback and help us
                    improve.</div> -->
            </div>
        </article>
        <!-- Rating Section -->
        <article class="feedback-rating">
            <div class="feedback-rating__ques">
                How was your experience with the Program?  <span class="mandatoryIcon"></span>
            </div>
            <div class="rating-icon" [(ngModel)]="feedback.rating" name="rating" ngDefaultControl required>
                <span class="icon-star cursor-pointer" *ngFor="let item of stars; let i=index"
                    [ngClass]="{'rating-selected': feedback.rating >= i+1}" (click)="startClicked(i+1)">
                    <span *ngIf="feedback.rating == i+1 && feedback.rating == 1">Unhappy</span>
                    <span *ngIf="feedback.rating == i+1 && feedback.rating == 2">Dissatisfied</span>
                    <span *ngIf="feedback.rating == i+1 && feedback.rating == 3">Okay</span>
                    <span *ngIf="feedback.rating == i+1 && feedback.rating == 4">Satisfied</span>
                    <span *ngIf="feedback.rating == i+1 && feedback.rating == 5">Thrilled</span>
                </span>
            </div>
            <!-- <div class="feedback-rating__star" [(ngModel)]="feedback.rating" name="rating" ngDefaultControl required>
                <div (click)="feedback.rating=1" [class.rating--text]="feedback.rating>0" class="rating"><span
                        class="icon-star"></span>
                    <p *ngIf="feedback.rating == 1">Worst</p>
                </div>
                <div (click)="feedback.rating=2" [class.rating--text]="feedback.rating>1" class="rating"><span
                        class="icon-star"></span>
                    <p *ngIf="feedback.rating == 2">Bad</p>
                </div>
                <div (click)="feedback.rating=3" [class.rating--text]="feedback.rating>2" class="rating"><span
                        class="icon-star"></span>
                    <p *ngIf="feedback.rating == 3">Neutral</p>
                </div>
                <div (click)="feedback.rating=4" [class.rating--text]="feedback.rating>3" class="rating"><span
                        class="icon-star"></span>
                    <p *ngIf="feedback.rating == 4">Good</p>
                </div>
                <div (click)="feedback.rating=5" [class.rating--text]="feedback.rating>4" class="rating"><span
                        class="icon-star"></span>
                    <p *ngIf="feedback.rating == 5">Excellent</p>
                </div>
            </div> -->

        </article>

        <article class="feedback-wrap">
            <!-- Answer Section -->
            <div class="feedback-content">
                <h2 class="feedback-content__ques">1. Which element(s) did you find to be useful in the program? <span class="mandatoryIcon"></span></h2>
                <p class="feedback-content__select">Choose as many as you like</p>
                <div class="feedback-content__ans">
                    <ul>
                        <li>
                            <label class="radio-cont">
                                <!-- checked="checked" -->
                                <input type="checkbox" name="radio" (click)="selectElement('Course Content')">
                                <span class="checkmark-black"></span>
                                <span class="ans--text">Course content</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="checkbox" name="radio" (click)="selectElement('Masterclasses')" /> <span
                                    class="checkmark-black"></span>
                                <span class="ans--text">Masterclasses</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="checkbox" name="radio" (click)="selectElement('Habit Drills')" /><span
                                    class="checkmark-black"></span>
                                <span class="ans--text">{{dynamicHabitDrillNomenclature}}</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="checkbox" name="radio" (click)="selectElement('Assessments')" /><span
                                    class="checkmark-black"></span>
                                <span class="ans--text">Assessments</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="checkbox" name="radio" (click)="selectElement('Other')" /><span
                                    class="checkmark-black"></span>
                                <span class="ans--text">Other</span>
                                <div class="ans--active"></div>
                            </label>
                            <div class="feedback-content" *ngIf="elementOther">
                                <div class="feedback-content__ans">
                                    <input type="text" name="other" placeholder="Type your answer here..."
                                        [(ngModel)]="feedback.elementUsefull.otherText" />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Answer Section End -->

            <!-- Answer Section -->
            <div class="feedback-content">
                <h2 class="feedback-content__ques">2. What all could have been better in this program ? <span
                        class="mandatoryIcon"></span>
                </h2>
                <p class="feedback-content__select">Choose as many as you like</p>
                <div class="feedback-content__ans">
                    <ul>
                        <li>
                            <label class="radio-cont">
                                <input type="checkbox" name="radio2" (click)="selectElementImporve('Course Content')">
                                <span class="checkmark-black"></span>
                                <span class="ans--text">Course content</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="checkbox" name="radio2"
                                    (click)="selectElementImporve('Faculty Videos')" /><span class="checkmark-black"></span>
                                <span class="ans--text">Faculty Videos</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="checkbox" name="radio2"
                                    (click)="selectElementImporve('Masterclasses')" /><span class="checkmark-black"></span>
                                <span class="ans--text">Masterclasses</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="checkbox" name="radio2" (click)="selectElementImporve('Habit Drills')" />
                                <span class="checkmark-black"></span>
                                <span class="ans--text">{{dynamicHabitDrillNomenclature}}</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="checkbox" name="radio2"
                                    (click)="selectElementImporve('Assessments')" /><span class="checkmark-black"></span>
                                <span class="ans--text">Assessments</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>

                        <!-- <li>
                            <label class="radio-cont">
                                <input type="checkbox" name="radio2" (click)="selectElementImporve('Others')" /><span
                                    class="checkmark-black"></span>
                                <span class="ans--text">Others</span>
                                <div class="ans--active"></div>
                            </label>
                        </li> -->
                    </ul>
                    <!-- <input type="text" placeholder="Type your answer here..."
                        [(ngModel)]="feedback.elementNeedImprovemet.otherText" name="otherText"
                        *ngIf="elementOtherImprove"> -->
                </div>
            </div>
            <!-- Answer Section End -->
            <!-- Answer Section -->
            <div class="feedback-content">
                <h2 class="feedback-content__ques mg-b30">
                    <p style="padding-right: 5px;">3. </p> Did you find the concepts taught in the program practical and useful? <span class="mandatoryIcon"></span>
                </h2>
                <!-- <p class="feedback-content__select opaacity-0">Choose as many as you like</p> -->
                <div class="feedback-content__ans">
                    <ul>
                        <li>
                            <label class="radio-cont">
                                <input type="radio" name="radio3" [(ngModel)]="feedback.conceptTaugths"
                                    value="Very Useful" />
                                <span class="checkmark-black"></span>
                                <span class="ans--text">Very Useful</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="radio" name="radio3" [(ngModel)]="feedback.conceptTaugths"
                                    value="Useful" />

                                <span class="checkmark-black"></span>
                                <span class="ans--text">Useful</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="radio" name="radio3" [(ngModel)]="feedback.conceptTaugths"
                                    value="Not Useful" /><span class="checkmark-black"></span>
                                <span class="ans--text">Not Useful</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Answer Section End -->
            <!-- Answer Section -->
            <div class="feedback-content">
                <h2 class="feedback-content__ques  mg-b30">
                    <p style="padding-right: 5px;">4. </p> <p>Did the email/whatsapp reminders encourage you to complete the program? <span class="mandatoryIcon"></span></p>
                </h2>
                <!-- <p class="feedback-content__select">Choose as many as you like</p> -->
                <div class="feedback-content__ans">
                    <ul>
                        <li>
                            <label class="radio-cont">
                                <input type="radio" name="radio4" [(ngModel)]="feedback.nudgesTaugths"
                                    value="Agree" />
                                <span class="checkmark-black"></span>
                                <span class="radio-cont__color"></span>
                                <span class="ans--text">Strongly Agree</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="radio" name="radio4" [(ngModel)]="feedback.nudgesTaugths" value="Disagree" />
                                <span class="checkmark-black"></span>
                                <span class="ans--text">Agree</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="radio" name="radio4" [(ngModel)]="feedback.nudgesTaugths"
                                    value="Maybe" /><span class="checkmark-black"></span>
                                <span class="ans--text">Neither agree or disagree</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="radio" name="radio4" [(ngModel)]="feedback.nudgesTaugths"
                                    value="Yes" /><span class="checkmark-black"></span>
                                <span class="ans--text">Disagree</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="radio" name="radio4" [(ngModel)]="feedback.nudgesTaugths"
                                    value="No" /><span class="checkmark-black"></span>
                                <span class="ans--text">Strongly Disagree</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <!-- <li>
                            <label class="radio-cont">
                                <input type="radio" name="radio4" [(ngModel)]="feedback.nudgesTaugths"
                                    value="Strongly Disagree" />
                                <span class="checkmark-black"></span>
                                <span class="ans--text">Strongly Disagree</span>
                                <div class="ans--active"></div>
                            </label>
                        </li>
                        <li>
                            <label class="radio-cont">
                                <input type="radio" checked="checked" name="radio4" [(ngModel)]="feedback.nudgesTaugths"
                                    value="Neither agree or disagree" />
                                <span class="checkmark-black"></span>
                                <span class="ans--text">Neither agree or disagree</span>
                                <div class="ans--active"></div>
                            </label>
                        </li> -->
                    </ul>
                </div>
            </div>
            <!-- Answer Section End -->
            <!-- Answer Section -->
            <div class="feedback-content">
                <h2 class="feedback-content__ques">5. What are your three key takeaways from this program?</h2>
                <p class="feedback-content__select">Optional</p>
                <div class="feedback-content__ans">
                    <input type="text" name="threeKeyTakeways" placeholder="Type your answer here..."
                        [(ngModel)]="feedback.threeKeyTakeways" />
                </div>
            </div>
            <!-- Answer Section End -->
            <!-- Answer Section -->
            <div class="feedback-content">
                <h2 class="feedback-content__ques">6. Do you have any suggestions to improve this program?</h2>
                <p class="feedback-content__select">Optional</p>
                <div class="feedback-content__ans">
                    <input type="text" name="significantlyImproved" placeholder="Type your answer here..."
                        [(ngModel)]="feedback.significantlyImproved" />
                </div>
            </div>
            <!-- Answer Section End -->

            <!-- Answer Section -->
            <div class="feedback-content terms-check--cont d-flex justify-content-between">
                <div class="feedback-content__ans">
                    <label class="checkbox-cont">
                        <input type="checkbox" name="stayInTouch" [(ngModel)]="feedback.stayInTouch">
                        <span class="checkbox-check"></span>
                    </label>
                </div>
                <div class="feedback-content__ans  terms--cont ">
                    <p class="feedback-content__ans__text">Please check this box if you would like us to stay in touch with you to regularly discuss your progress. We will reach out to you via email for quick interviews and testimonials.</p>
                </div>
            </div>
            <!-- Answer Section End -->
            <!-- Terms Section -->
            <!-- <div class="feedback-content terms--cont hide-on-mobile">
                <div class="feedback-content__ans">
                    <p class="feedback-content__ans__text">Would like us to stay in touch with you to regularly discuss
                        your progress. We will reach
                        out to you via email for quick interviews and testimonials.</p>
                </div>
            </div> -->
            <!-- Terms Section End -->
            <!-- Footer Button Section -->
            <div class="feedback-content feedback--button">
                <!-- <button type="button"
                    class="light-color link-no-underline trans--button pd-t10 pd-b10 pd-l20 pd-r20">Back</button> -->
                <button type="submit"
                    class="light-color link-no-underline red--button pd-t10 pd-b10 pd-l20 pd-r20">Submit</button>
            </div>
            <!-- Footer Button Section End -->

        </article>
    </div>
</form>
<!-- </section> -->
